import { gql } from '@apollo/client';
import { CONSTRAINT_FIELDS_FRAGMENT } from './fragments';

/**
 * Constraint GraphQL Mutations - 7 mutations for Formula #4 support
 */

export const CREATE_CONSTRAINT = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  mutation CreateConstraint($tenantId: String!, $input: GqlCreateConstraintInput!) {
    createConstraint(tenantId: $tenantId, input: $input) {
      ...ConstraintFields
    }
  }
`;

export const UPDATE_CONSTRAINT = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  mutation UpdateConstraint($tenantId: String!, $constraintId: String!, $input: GqlUpdateConstraintInput!) {
    updateConstraint(tenantId: $tenantId, constraintId: $constraintId, input: $input) {
      ...ConstraintFields
    }
  }
`;

export const INCREMENT_USAGE = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  mutation IncrementUsage($tenantId: String!, $constraintId: String!, $amount: Float!) {
    incrementUsage(tenantId: $tenantId, constraintId: $constraintId, amount: $amount) {
      ...ConstraintFields
    }
  }
`;

export const RESET_USAGE = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  mutation ResetUsage($tenantId: String!, $constraintId: String!) {
    resetUsage(tenantId: $tenantId, constraintId: $constraintId) {
      ...ConstraintFields
    }
  }
`;

export const RECORD_VIOLATION = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  mutation RecordViolation($tenantId: String!, $constraintId: String!, $input: GqlRecordViolationInput!) {
    recordViolation(tenantId: $tenantId, constraintId: $constraintId, input: $input) {
      ...ConstraintFields
    }
  }
`;

export const DISABLE_CONSTRAINT = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  mutation DisableConstraint($tenantId: String!, $constraintId: String!, $reason: String!) {
    disableConstraint(tenantId: $tenantId, constraintId: $constraintId, reason: $reason) {
      ...ConstraintFields
    }
  }
`;

export const ENABLE_CONSTRAINT = gql`
  ${CONSTRAINT_FIELDS_FRAGMENT}
  mutation EnableConstraint($tenantId: String!, $constraintId: String!) {
    enableConstraint(tenantId: $tenantId, constraintId: $constraintId) {
      ...ConstraintFields
    }
  }
`;
